import { ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CertificatesCardComponent } from "../../components/cards/certificates-card/certificates-card.component";

@Component({
    selector: 'app-certificates',
    standalone: true,
    templateUrl: './certificates.component.html',
    styleUrls: ['./certificates.component.scss'],
    imports: [CommonModule, CertificatesCardComponent]
})
export class CertificatesComponent {
  hasCertificates: boolean = true;

  constructor(private cdRef: ChangeDetectorRef) {}

  message($event: any) {
    this.hasCertificates = $event;
    this.cdRef.detectChanges();
  }

}
